"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractEventSignature = exports.ContractEventType = void 0;
var ContractEventType;
(function (ContractEventType) {
    // MODULE:ERC20
    ContractEventType["Approval"] = "Approval";
    ContractEventType["Transfer"] = "Transfer";
    // MODULE:ERC721
    ContractEventType["ApprovalForAll"] = "ApprovalForAll";
    ContractEventType["DefaultRoyaltyInfo"] = "DefaultRoyaltyInfo";
    ContractEventType["MintRandom"] = "MintRandom";
    ContractEventType["TokenRoyaltyInfo"] = "TokenRoyaltyInfo";
    ContractEventType["ConsecutiveTransfer"] = "ConsecutiveTransfer";
    // Approval = "Approval",
    // Transfer = "Transfer",
    // MODULE:ERC998
    ContractEventType["BatchReceivedChild"] = "BatchReceivedChild";
    ContractEventType["BatchTransferChild"] = "BatchTransferChild";
    ContractEventType["WhitelistedChild"] = "WhitelistedChild";
    ContractEventType["UnWhitelistedChild"] = "UnWhitelistedChild";
    ContractEventType["ReceivedChild"] = "ReceivedChild";
    ContractEventType["TransferChild"] = "TransferChild";
    ContractEventType["SetMaxChild"] = "SetMaxChild";
    // MODULE:ERC1155
    ContractEventType["TransferBatch"] = "TransferBatch";
    ContractEventType["TransferSingle"] = "TransferSingle";
    ContractEventType["URI"] = "URI";
    // MODULE:LOTTERY
    ContractEventType["RoundFinalized"] = "RoundFinalized";
    ContractEventType["RoundStarted"] = "RoundStarted";
    ContractEventType["RoundEnded"] = "RoundEnded";
    ContractEventType["PurchaseLottery"] = "PurchaseLottery";
    ContractEventType["PurchaseRaffle"] = "PurchaseRaffle";
    ContractEventType["Released"] = "Released";
    ContractEventType["Prize"] = "Prize";
    // MODULE:WRAPPER
    ContractEventType["UnpackWrapper"] = "UnpackWrapper";
    // MODULE:LOOT
    ContractEventType["UnpackLootBox"] = "UnpackLootBox";
    // MODULE:MYSTERY
    ContractEventType["UnpackMysteryBox"] = "UnpackMysteryBox";
    // MODULE:PAUSE
    ContractEventType["Paused"] = "Paused";
    ContractEventType["Unpaused"] = "Unpaused";
    // MODULE:VESTING
    ContractEventType["EtherReleased"] = "EtherReleased";
    ContractEventType["ERC20Released"] = "ERC20Released";
    ContractEventType["EtherReceived"] = "EtherReceived";
    // MODULE:ACCESS_LIST
    ContractEventType["Blacklisted"] = "Blacklisted";
    ContractEventType["UnBlacklisted"] = "UnBlacklisted";
    ContractEventType["Whitelisted"] = "Whitelisted";
    ContractEventType["UnWhitelisted"] = "UnWhitelisted";
    // MODULE:ACCESS_CONTROL
    ContractEventType["RoleGranted"] = "RoleGranted";
    ContractEventType["RoleRevoked"] = "RoleRevoked";
    ContractEventType["RoleAdminChanged"] = "RoleAdminChanged";
    ContractEventType["DefaultAdminTransferScheduled"] = "DefaultAdminTransferScheduled";
    ContractEventType["DefaultAdminTransferCanceled"] = "DefaultAdminTransferCanceled";
    ContractEventType["DefaultAdminDelayChangeScheduled"] = "DefaultAdminDelayChangeScheduled";
    ContractEventType["DefaultAdminDelayChangeCanceled"] = "DefaultAdminDelayChangeCanceled";
    ContractEventType["OwnershipTransferred"] = "OwnershipTransferred";
    ContractEventType["OwnershipTransferStarted"] = "OwnershipTransferStarted";
    // MODULE:STAKING
    ContractEventType["RuleCreated"] = "RuleCreated";
    ContractEventType["RuleUpdated"] = "RuleUpdated";
    ContractEventType["StakingStart"] = "StakingStart";
    ContractEventType["StakingWithdraw"] = "StakingWithdraw";
    ContractEventType["StakingFinish"] = "StakingFinish";
    ContractEventType["WithdrawBalance"] = "WithdrawBalance";
    ContractEventType["ReturnDeposit"] = "ReturnDeposit";
    ContractEventType["DepositPenalty"] = "DepositPenalty";
    ContractEventType["DepositStart"] = "DepositStart";
    ContractEventType["DepositWithdraw"] = "DepositWithdraw";
    // MODULE:PONZI
    ContractEventType["RuleCreatedP"] = "RuleCreatedP";
    // MODULE:EXCHANGE
    // MODULE:CORE
    ContractEventType["Purchase"] = "Purchase";
    // MODULE:CLAIM
    ContractEventType["Claim"] = "Claim";
    // MODULE:CRAFT
    ContractEventType["Craft"] = "Craft";
    ContractEventType["Dismantle"] = "Dismantle";
    ContractEventType["Merge"] = "Merge";
    // MODULE:RENTABLE
    ContractEventType["UpdateUser"] = "UpdateUser";
    ContractEventType["Lend"] = "Lend";
    // MODULE:LOOT
    ContractEventType["PurchaseLootBox"] = "PurchaseLootBox";
    // MODULE:MYSTERY
    ContractEventType["PurchaseMysteryBox"] = "PurchaseMysteryBox";
    // MODULE:METADATA
    ContractEventType["UpdMetadata"] = "UpdMetadata";
    // MODULE:DISCRETE
    ContractEventType["Upgrade"] = "Upgrade";
    // MODULE:WAITLIST
    ContractEventType["WaitListRewardSet"] = "WaitListRewardSet";
    ContractEventType["WaitListRewardClaimed"] = "WaitListRewardClaimed";
    // MODULE:BREEDING
    ContractEventType["Breed"] = "Breed";
    // MODULE:DISCRETE
    ContractEventType["LevelUp"] = "LevelUp";
    ContractEventType["MetadataUpdate"] = "MetadataUpdate";
    ContractEventType["BatchMetadataUpdate"] = "BatchMetadataUpdate";
    // MODULE:PAYMENT_SPLITTER
    ContractEventType["PayeeAdded"] = "PayeeAdded";
    ContractEventType["PaymentReleased"] = "PaymentReleased";
    ContractEventType["PaymentReceived"] = "PaymentReceived";
    ContractEventType["ERC20PaymentReleased"] = "ERC20PaymentReleased";
    // MODULE:CHAINLINK
    ContractEventType["RandomnessRequest"] = "RandomnessRequest";
    ContractEventType["RandomnessRequestId"] = "RandomnessRequestId";
    ContractEventType["SubscriptionCreated"] = "SubscriptionCreated";
    // MODULE:CHAINLINKV2
    ContractEventType["RandomWordsRequested"] = "RandomWordsRequested";
    ContractEventType["VrfSubscriptionSet"] = "VrfSubscriptionSet";
    ContractEventType["SubscriptionConsumerAdded"] = "SubscriptionConsumerAdded";
    // MODULE:ECOMMERCE
    ContractEventType["EcommercePurchase"] = "EcommercePurchase";
    // MODULE:REFERRAL
    ContractEventType["ReferralEvent"] = "ReferralEvent";
    ContractEventType["ReferralProgram"] = "ReferralProgram";
    ContractEventType["ReferralReward"] = "ReferralReward";
    ContractEventType["ReferralWithdraw"] = "ReferralWithdraw";
    // BASE URI
    ContractEventType["BaseURIUpdate"] = "BaseURIUpdate";
})(ContractEventType || (exports.ContractEventType = ContractEventType = {}));
var ContractEventSignature;
(function (ContractEventSignature) {
    // MODULE:ERC20
    ContractEventSignature["Approval"] = "Approval(address,address,uint256)";
    ContractEventSignature["Transfer"] = "Transfer(address,address,uint256)";
    // MODULE:ERC721
    ContractEventSignature["ApprovalForAll"] = "ApprovalForAll(address,address,bool)";
    ContractEventSignature["DefaultRoyaltyInfo"] = "DefaultRoyaltyInfo(address,uint96)";
    ContractEventSignature["MintRandom"] = "MintRandom(uint256,address,uint256[],uint256,uint256)";
    ContractEventSignature["TokenRoyaltyInfo"] = "TokenRoyaltyInfo(uint256,address,uint96)";
    ContractEventSignature["ConsecutiveTransfer"] = "ConsecutiveTransfer(uint256,uint256,address,address)";
    // Approval = "Approval",
    // Transfer = "Transfer",
    // MODULE:ERC998
    ContractEventSignature["BatchReceivedChild"] = "BatchReceivedChild(address,uint256,address,uint256[],uint256[])";
    ContractEventSignature["BatchTransferChild"] = "BatchTransferChild(uint256,address,address,uint256[],uint256[])";
    ContractEventSignature["WhitelistedChild"] = "WhitelistedChild(address,uint256)";
    ContractEventSignature["UnWhitelistedChild"] = "UnWhitelistedChild(address)";
    ContractEventSignature["ReceivedChild"] = "ReceivedChild(address,uint256,address,uint256,uint256)";
    ContractEventSignature["TransferChild"] = "TransferChild(uint256,address,address,uint256,uint256)";
    ContractEventSignature["SetMaxChild"] = "SetMaxChild(address,uint256)";
    // MODULE:ERC1155
    ContractEventSignature["TransferBatch"] = "TransferBatch(address,address,address,uint256[],uint256[])";
    ContractEventSignature["TransferSingle"] = "TransferSingle(address,address,address,uint256,uint256)";
    ContractEventSignature["URI"] = "URI(string,uint256)";
    // event Merge(address account, uint256 externalId, Asset[] items, Asset[] price);
    // MODULE:MERGE
    ContractEventSignature["Merge"] = "Merge(address,uint256,(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[])";
    // MODULE:RAFFLE
    // event RoundFinalized(uint256 round, uint256 prizeIndex, uint256 prizeNumber);
    ContractEventSignature["RoundFinalizedRaffle"] = "RoundFinalized(uint256,uint256,uint256)";
    // MODULE:LOTTERY
    ContractEventSignature["RoundFinalized"] = "RoundFinalized(uint256,uint8[6])";
    // event RoundStarted(uint256 roundId, uint256 startTimestamp, uint256 maxTicket, Asset ticket, Asset price);
    ContractEventSignature["RoundStarted"] = "RoundStarted(uint256,uint256,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256))";
    ContractEventSignature["RoundEnded"] = "RoundEnded(uint256,uint256)";
    // event PurchaseLottery(address account, uint256 externalId, Asset item, Asset price, uint256 roundId, bytes32 numbers);
    ContractEventSignature["PurchaseLottery"] = "PurchaseLottery(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256),uint256,bytes32)";
    // event PurchaseRaffle(address account, uint256 externalId, Asset item, Asset price, uint256 roundId, uint256 index);
    ContractEventSignature["PurchaseRaffle"] = "PurchaseRaffle(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256),uint256,uint256)";
    ContractEventSignature["Released"] = "Released(uint256,uint256)";
    ContractEventSignature["Prize"] = "Prize(address,uint256,uint256,uint256)";
    // MODULE:WRAPPER
    ContractEventSignature["UnpackWrapper"] = "UnpackWrapper(address,uint256)";
    // MODULE:LOOT
    ContractEventSignature["UnpackLootBox"] = "UnpackLootBox(address,uint256)";
    // MODULE:MYSTERY
    ContractEventSignature["UnpackMysteryBox"] = "UnpackMysteryBox(address,uint256)";
    // MODULE:PAUSE
    ContractEventSignature["Paused"] = "Paused(address)";
    ContractEventSignature["Unpaused"] = "Unpaused(address)";
    // MODULE:VESTING
    ContractEventSignature["EtherReleased"] = "EtherReleased(uint256)";
    ContractEventSignature["ERC20Released"] = "ERC20Released(address,uint256)";
    // TODO remove
    ContractEventSignature["EtherReceived"] = "EtherReceived()";
    // MODULE:ACCESS_LIST
    ContractEventSignature["Blacklisted"] = "Blacklisted(address)";
    ContractEventSignature["UnBlacklisted"] = "UnBlacklisted(address)";
    ContractEventSignature["Whitelisted"] = "Whitelisted(address)";
    ContractEventSignature["UnWhitelisted"] = "UnWhitelisted(address)";
    // MODULE:ACCESS_CONTROL
    ContractEventSignature["RoleGranted"] = "RoleGranted(bytes32,address,address)";
    ContractEventSignature["RoleRevoked"] = "RoleRevoked(bytes32,address,address)";
    ContractEventSignature["RoleAdminChanged"] = "RoleAdminChanged(bytes32,bytes32,bytes32)";
    ContractEventSignature["DefaultAdminTransferScheduled"] = "DefaultAdminTransferScheduled(address,uint48)";
    ContractEventSignature["DefaultAdminTransferCanceled"] = "DefaultAdminTransferCanceled()";
    ContractEventSignature["DefaultAdminDelayChangeScheduled"] = "DefaultAdminDelayChangeScheduled(uint48,uint48)";
    ContractEventSignature["DefaultAdminDelayChangeCanceled"] = "DefaultAdminDelayChangeCanceled()";
    ContractEventSignature["OwnershipTransferred"] = "OwnershipTransferred(address,address)";
    ContractEventSignature["OwnershipTransferStarted"] = "OwnershipTransferStarted(address,address)";
    // MODULE:STAKING
    // event RuleCreated(uint256 ruleId, Rule rule);
    ContractEventSignature["RuleCreated"] = "RuleCreated(uint256,((uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[][],(uint256,uint256,uint256,bool,bool),bool))";
    ContractEventSignature["RuleUpdated"] = "RuleUpdated(uint256,bool)";
    ContractEventSignature["StakingStart"] = "StakingStart(uint256,uint256,address,uint256,uint256)";
    ContractEventSignature["StakingWithdraw"] = "StakingWithdraw(uint256,address,uint256)";
    ContractEventSignature["StakingFinish"] = "StakingFinish(uint256,address,uint256,uint256)";
    ContractEventSignature["BalanceWithdraw"] = "BalanceWithdraw(address,(uint8,address,uint256,uint256))";
    ContractEventSignature["DepositReturn"] = "DepositReturn(uint256,address)";
    ContractEventSignature["DepositStart"] = "DepositStart(uint256,uint256,address,uint256,uint256[])";
    ContractEventSignature["DepositWithdraw"] = "DepositWithdraw(uint256,address,uint256)";
    ContractEventSignature["DepositFinish"] = "DepositFinish(uint256,address,uint256,uint256)";
    ContractEventSignature["DepositPenalty"] = "DepositPenalty(uint256,(uint8,address,uint256,uint256))";
    // MODULE:EXCHANGE
    // MODULE:CORE
    // event Purchase(address account, uint256 externalId, Asset item, Asset[] price);
    ContractEventSignature["Purchase"] = "Purchase(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256)[])";
    // MODULE:CLAIM
    // event Claim(address account, uint256 externalId, Asset[] items);
    ContractEventSignature["Claim"] = "Claim(address,uint256,(uint8,address,uint256,uint256)[])";
    // MODULE:CRAFT
    // event Craft(address from, uint256 externalId, Asset[] items, Asset[] price);
    ContractEventSignature["Craft"] = "Craft(address,uint256,(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[])";
    // MODULE:RENTABLE
    ContractEventSignature["UpdateUser"] = "UpdateUser(uint256,address,uint64)";
    // event Lend(address from, address to, uint64 expires, uint256 externalId, Asset item, Asset[] price);
    // event LendMany(address from, address to, uint64 expires, uint256 externalId, Asset[] items, Asset[] price);
    ContractEventSignature["Lend"] = "Lend(address,address,uint64,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256)[])";
    ContractEventSignature["LendMany"] = "LendMany(address,address,uint64,uint256,(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[])";
    // MODULE:LOOT
    // event PurchaseLootBox(address account, uint256 externalId, Asset[] items, Asset[] price);
    ContractEventSignature["PurchaseLootBox"] = "PurchaseLootBox(address,uint256,(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[])";
    // MODULE:MYSTERY
    // event PurchaseMysteryBox(address account, uint256 externalId, Asset[] items, Asset[] price);
    ContractEventSignature["PurchaseMysteryBox"] = "PurchaseMysteryBox(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[])";
    // MODULE:METADATA
    // event UpdMetadata(address account, uint256 externalId, Asset item, Asset[] price, Metadata[] metadata);
    ContractEventSignature["UpdMetadata"] = "UpdMetadata(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256)[],(bytes32,uint256)[])";
    // MODULE:DISCRETE
    // event Upgrade(address account, uint256 externalId, Asset item, Asset[] price, bytes32 attribute, uint256 level);
    ContractEventSignature["Upgrade"] = "Upgrade(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256)[],bytes32,uint256)";
    // MODULE:WAITLIST
    //   event WaitListRewardSet(uint256 externalId, bytes32 root, Asset[] items);
    //   event WaitListRewardClaimed(address account, uint256 externalId, Asset[] items);
    ContractEventSignature["WaitListRewardSet"] = "WaitListRewardSet(uint256,bytes32,(uint8,address,uint256,uint256)[])";
    ContractEventSignature["WaitListRewardClaimed"] = "WaitListRewardClaimed(address,uint256,(uint8,address,uint256,uint256)[])";
    // MODULE:BREEDING
    // event Breed(address from, uint256 externalId, Asset matron, Asset sire);
    ContractEventSignature["Breed"] = "Breed(address,uint256,(uint8,address,uint256,uint256),(uint8,address,uint256,uint256))";
    // MODULE:DISCRETE
    // event LevelUp(address account, uint256 tokenId, bytes32 attribute, uint256 value);
    ContractEventSignature["LevelUp"] = "LevelUp(address,uint256,bytes32,uint256)";
    // MODULE:DISMANTLE
    ContractEventSignature["Dismantle"] = "Dismantle(address,uint256,(uint8,address,uint256,uint256)[],(uint8,address,uint256,uint256)[])";
    ContractEventSignature["MetadataUpdate"] = "MetadataUpdate(uint256)";
    ContractEventSignature["BatchMetadataUpdate"] = "BatchMetadataUpdate(uint256,uint256)";
    // MODULE:PAYMENT_SPLITTER
    ContractEventSignature["PayeeAdded"] = "PayeeAdded(address,uint256)";
    ContractEventSignature["PaymentReleased"] = "PaymentReleased(address,uint256)";
    ContractEventSignature["PaymentReceived"] = "PaymentReceived(address,uint256)";
    ContractEventSignature["ERC20PaymentReleased"] = "ERC20PaymentReleased(address,address,uint256)";
    // MODULE:PONZI
    ContractEventSignature["RuleCreatedP"] = "RuleCreatedP(uint256,((uint8,address,uint256,uint256),(uint8,address,uint256,uint256),(uint256,uint256,uint256),bool))";
    ContractEventSignature["FinalizedToken"] = "FinalizedToken(address,uint256)";
    ContractEventSignature["WithdrawToken"] = "WithdrawToken(address,uint256)";
    ContractEventSignature["ReferralBonus"] = "ReferralBonus(address,address,uint256)";
    // MODULE:CHAINLINKV2
    ContractEventSignature["RandomWordsRequested"] = "RandomWordsRequested(bytes32,uint256,uint256,uint256,uint16,uint32,uint32,bytes,address)";
    ContractEventSignature["RandomnessRequestId"] = "RandomnessRequestId(bytes32,address)";
    ContractEventSignature["SubscriptionConsumerAdded"] = "SubscriptionConsumerAdded(uint64,address)";
    ContractEventSignature["SubscriptionCreated"] = "SubscriptionCreated(uint64,address)";
    ContractEventSignature["VrfSubscriptionSet"] = "VrfSubscriptionSet(uint256)";
    // MODULE:ECOMMERCE
    ContractEventSignature["EcommercePurchase"] = "EcommercePurchase(??)";
    // MODULE:REFERRAL
    ContractEventSignature["ReferralEvent"] = "ReferralEvent(address,address,(uint8,address,uint256,uint256)[])";
    ContractEventSignature["ReferralProgram"] = "ReferralProgram((uint256,uint256,uint8,bool))";
    ContractEventSignature["ReferralReward"] = "ReferralReward(address,address,uint8,address,uint256)";
    ContractEventSignature["ReferralWithdraw"] = "ReferralWithdraw(address,address,uint256)";
    // MODULE:CM
    // event VestingDeployed(address account, uint256 externalId, VestingArgs args, Asset[] items);
    ContractEventSignature["VestingDeployed"] = "VestingDeployed(address,uint256,(address,uint64,uint16,uint16,string),(uint8,address,uint256,uint256)[])";
    // event ERC20TokenDeployed(address account, uint256 externalId, Erc20Args args);
    ContractEventSignature["ERC20TokenDeployed"] = "ERC20TokenDeployed(address,uint256,(string,string,uint256,string))";
    ContractEventSignature["ERC721TokenDeployed"] = "ERC721TokenDeployed(address,uint256,(string,string,uint96,string,string))";
    ContractEventSignature["ERC998TokenDeployed"] = "ERC998TokenDeployed(address,uint256,(string,string,uint96,string,string))";
    ContractEventSignature["ERC1155TokenDeployed"] = "ERC1155TokenDeployed(address,uint256,(uint96,string,string))";
    ContractEventSignature["LootBoxDeployed"] = "LootBoxDeployed(address,uint256,(string,string,uint96,string,string))";
    ContractEventSignature["MysteryBoxDeployed"] = "MysteryBoxDeployed(address,uint256,(string,string,uint96,string,string))";
    ContractEventSignature["CollectionDeployed"] = "CollectionDeployed(address,uint256,(string,string,uint96,string,uint96,string))";
    ContractEventSignature["PonziDeployed"] = "PonziDeployed(address,uint256,(address[],uint256[],string))";
    ContractEventSignature["StakingDeployed"] = "StakingDeployed(address,uint256,(string))";
    ContractEventSignature["LotteryDeployed"] = "LotteryDeployed(address,uint256,((uint256,uint256)))";
    ContractEventSignature["RaffleDeployed"] = "RaffleDeployed(address,uint256)";
    ContractEventSignature["WaitListDeployed"] = "WaitListDeployed(address,uint256)";
    // event PaymentSplitterDeployed(address account, uint256 externalId, PaymentSplitterArgs args);
    ContractEventSignature["PaymentSplitterDeployed"] = "PaymentSplitterDeployed(address,uint256,(address[],uint256[]))";
    // MODULE:ERC1363
    ContractEventSignature["TransferReceived"] = "TransferReceived(address,address,uint256,bytes)";
    // BASE URI
    ContractEventSignature["BaseURIUpdate"] = "BaseURIUpdate(string)";
})(ContractEventSignature || (exports.ContractEventSignature = ContractEventSignature = {}));
//# sourceMappingURL=event.js.map